/* change later */
import { SmlJsonQuery } from "@src/types/intelligence-search";
import React, { createContext, useContext } from "react";
import { SmlQueryProvider } from "./sml-query-context";
import dayjs from "dayjs";

type SmlQueryBuilderContextType = {
    queryKey: string;
    productCode?: string;
    timeRange?: dayjs.Dayjs[];
    rawJsonQuery?: SmlJsonQuery;
    getGeneratedJsonQuery: (jsonQuery?: SmlJsonQuery) => SmlJsonQuery | undefined;
    getBase64EncodedJsonQuery: () => string | undefined;
    isValidQuery: () => boolean;
};

type SmlQueryBuilderProviderProps = React.PropsWithChildren & {
    queryKey: string;
    productCode?: string;
    timeRange?: dayjs.Dayjs[];
    rawJsonQuery?: SmlJsonQuery;
    getGeneratedJsonQuery: (jsonQuery?: SmlJsonQuery) => SmlJsonQuery | undefined;
};

export const SmlQueryBuilderContext = createContext({} as SmlQueryBuilderContextType);

export const SmlQueryBuilderProvider: React.FC<SmlQueryBuilderProviderProps> = ({
    children,
    queryKey,
    productCode,
    timeRange,
    rawJsonQuery,
    getGeneratedJsonQuery,
}) => {
    const jsonQuery = getGeneratedJsonQuery();

    const isValidQuery = React.useCallback(() => {
        return (
            (jsonQuery?.select ?? [])?.length > 0 ||
            (jsonQuery?.orders ?? [])?.length > 0 ||
            (jsonQuery?.filters ?? [])?.length > 0
        );
    }, [jsonQuery]);

    const getBase64EncodedJsonQuery = () => {
        return jsonQuery ? btoa(JSON.stringify(jsonQuery)) : undefined;
    };

    return (
        <SmlQueryBuilderContext.Provider
            value={{
                productCode,
                queryKey,
                rawJsonQuery,
                timeRange,
                getGeneratedJsonQuery,
                getBase64EncodedJsonQuery,
                isValidQuery,
            }}
        >
            <SmlQueryProvider queryKey={queryKey}>{children}</SmlQueryProvider>
        </SmlQueryBuilderContext.Provider>
    );
};
export const useSmlQueryBuilderContext = () => useContext(SmlQueryBuilderContext);
